import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import {
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIblockTerm, APIdeleteTerm } from '../../../api/Metadata';

import { showModal } from '../../../actions';
import { addFlashMessage, showConfirmationModal } from '../../../actions/App';
import { fetchTaxonomies } from '../../../actions/Metadata';

import EmptyTableCell from '../../EmptyTableCell';

const AdminTermsListItem = ({
  term,
  selectedTerms,
  handleDeleteTerm,
  deleteTermFromList,
  handleSelectTerm,
  openTermEditModal,
  openTermMoveModal,
  updateTermOnList,
  refreshTermList,
  taxonomy,
}) => {
  const intl = useIntl();

  const handleEdit = (e) => {
    e.preventDefault();
    openTermEditModal({
      className: 'modal-edit-term',
      backdrop: true,
      term,
      afterCreateTerm: updateTermOnList,
      aiTagging: taxonomy.ai_tagging,
    });
  };

  const handleMove = (e) => {
    e.preventDefault();
    openTermMoveModal({
      className: 'modal-move-term',
      selectedTermsIds: [term.id],
      taxonomyId: term.taxonomy_id.toString(),
      afterMoveTerm: refreshTermList,
    });
  };

  const handleBlock = async () => {
    try {
      const response = await APIblockTerm(
        { taxonomyId: term.taxonomy_id, terms: [term.id], blocked: !term.blocked },
      );
      if (response.status !== 200) {
        throw new Error(intl.formatMessage({ defaultMessage: 'An error occured' }));
      }
      refreshTermList();
      addFlashMessage({
        type: 'success',
        text: response.data.blocked ?
          intl.formatMessage({ defaultMessage: 'Tag have been blocked' }) :
          intl.formatMessage({ defaultMessage: 'Tag have been unblocked' }),
      });
    } catch (e) {
      addFlashMessage({
        type: 'danger',
        text: intl.formatMessage({ defaultMessage: 'Error occured while blocking tags' }),
      });
    }
  };

  return (
    <tr>
      <td className="selector">
        <Input
          type="checkbox"
          name="selected-user"
          value={term.id}
          checked={selectedTerms.includes(term.id)}
          onChange={handleSelectTerm}
        />
      </td>
      <th scope="row" className="term-name">
        <a
          href="#edit"
          onClick={handleEdit}
        >
          {term.name}
        </a>
      </th>
      <td className="term-files">
        {term.blocked ? (
          <span>
            <i className="fal fa-dash" />
          </span>
        ) : (
          <Link to={`/files/?terms=${term.id}`} target="_blank">
            {term.files}
          </Link>
        )}
      </td>
      <td className="term-blocked">
        {term.blocked ? (
          <i className="far fa-xmark" />
        ) : <EmptyTableCell />}
      </td>
      <td className="action-more">
        <UncontrolledDropdown>
          <DropdownToggle nav className="options">
            <i className="far fa-ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu right container="body">
            <DropdownItem
              onClick={handleEdit}
            >
              <i className="fa-fw fas fa-pencil" />
              {intl.formatMessage({ defaultMessage: 'Edit' })}
            </DropdownItem>
            <DropdownItem
              onClick={handleMove}
            >
              <i className="fa-fw fas fa-shuffle" />
              {intl.formatMessage({ defaultMessage: 'Move' })}
            </DropdownItem>
            <DropdownItem
              onClick={handleBlock}
            >
              <i className="fa-fw fas fa-xmark" />
              {term.blocked ?
                intl.formatMessage({ defaultMessage: 'Unblock' }) :
                intl.formatMessage({ defaultMessage: 'Block' })}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem
              onClick={(e) => {
                e.preventDefault();
                handleDeleteTerm(intl, term, deleteTermFromList);
              }}
            >
              <i className="fa-fw fas fa-trash" />
              {intl.formatMessage({ defaultMessage: 'Delete' })}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </td>
    </tr>
  );
};

const mapDispatchToProps = (dispatch) => ({
  openTermEditModal: (params) => {
    dispatch(showModal('TermEditModal', params));
  },
  openTermMoveModal: (params) => {
    dispatch(showModal('TermMoveModal', params));
  },
  handleDeleteTerm: (intl, term, callback) => {
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: `Are you sure you want to delete this tag? Doing this will not delete
          the files associated with it, but the tag will be permanently removed.`,
      }),
      onConfirm: () => (
        APIdeleteTerm(term.id).then(() => {
          dispatch(fetchTaxonomies());
          callback(term);
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

AdminTermsListItem.propTypes = {
  taxonomy: PropTypes.object.isRequired,
  openTermEditModal: PropTypes.func.isRequired,
  handleDeleteTerm: PropTypes.func.isRequired,
  openTermMoveModal: PropTypes.func.isRequired,
  updateTermOnList: PropTypes.func.isRequired,
  refreshTermList: PropTypes.func.isRequired,
  deleteTermFromList: PropTypes.func.isRequired,
  term: PropTypes.object.isRequired,
  selectedTerms: PropTypes.array.isRequired,
  handleSelectTerm: PropTypes.func.isRequired,
};

export default withRouter(connect(null, mapDispatchToProps)(AdminTermsListItem));
